import React, { Component } from 'react';
import axios from 'axios';

import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';

import Images from './Images';

class SearchPixabay extends Component {
	state = {
		apiKey: '15877490-40886f70818827c447d2f6dfd',
		amount: 5,
		query: '',
		images: []
	}

	// Using Pexels API to get photos

	handleChange = (e) => {
		const val = e.target.value.trim();
		// make sure input feild name and state matches
		this.setState({ [e.target.name]: val }, () => {
			if(val === '') {
				this.setState({ images: []});
			} else {
				axios.get(`https://pixabay.com/api/?key=${this.state.apiKey}&q=${this.state.query}&image_type=photo&per_page=${this.state.amount}`)
				.then(res => {
					// console.log(res.data.hits);
					this.setState({
						images: res.data.hits
					})
				})
				.catch(err => console.log(err));
			}
		});
		// this.getImage();
		
	}
	handleSelect = (e) => {
		// console.log(value);
		this.setState({
			[e.target.name]: e.target.value // make sure input feild name and state matches
		});
	}

	render() {
		// console.log(this.state.images);
		// const { classes } = this.props;
		const { images } = this.state;
		return (
			<div>
				<TextField 
					name="query"
					value={ this.state.query }
					onChange={ this.handleChange }
					label="Search for an image ..."
					fullWidth={ true }
					autoComplete="off"
					color="secondary"
				/>
				<br />
				<InputLabel style={{marginTop: '30px'}}>Select amount:</InputLabel>
				<Select
					name="amount"
					value={ this.state.amount }
					onChange={ this.handleSelect }
					displayEmpty
					color="secondary"
					inputProps={{ 'aria-label': 'Without label' }}
				>
					<MenuItem value={5}><em>5</em></MenuItem>
					<MenuItem value={10}>10</MenuItem>
					<MenuItem value={25}>25</MenuItem>
					<MenuItem value={50}>50</MenuItem>
				</Select>
				<br />
				<div style={{height: '30px'}}></div>
				{images.length > 0 ? (
						<Images images={images} title={this.state.query} />
					) : (
						<div>No Image Found</div>
					)
				}
			</div>
		)
	}
}

export default SearchPixabay;